export default __webpack_public_path__ + "static/media/celuba-2.a4551e97.jpg";